import * as bootstrap from "bootstrap";
import {escapeHtml} from "./utils/escapeHtml.js";

document.addEventListener("DOMContentLoaded", () => {
    initConfirmDelete();
    initConfirmAction();
    initConfirmActionReason();
    initPopoverReason();

    const dialog = document.getElementById("dialog");
    if (dialog) {
        dialog.addEventListener("hidden.bs.modal", () => {
            dialog.classList.remove("show");
        });
    }

    const navbarTogglers = document.querySelectorAll(".navbar-toggler");
    navbarTogglers.forEach(toggler => {
        toggler.addEventListener("click", () => {
            toggler.classList.toggle("active");
        });
    });
    const profileDropDown = document.getElementById("profile-dropdown");
    const avatarCircle = document.querySelector(".avatar-circle");

    if (profileDropDown) {
        profileDropDown.addEventListener("show.bs.dropdown", () => {
            avatarCircle.classList.add("active");
        });

        profileDropDown.addEventListener("hide.bs.dropdown", () => {
            avatarCircle.classList.remove("active");
        });
    }

    const toggleFilters = document.querySelector("a.toggle-filters");
    const filtersContainer = document.querySelector(".filters-container");
    if (toggleFilters && filtersContainer) {
        toggleFilters.addEventListener("click", () => {
            event.preventDefault();

            if (filtersContainer.classList.contains("open")) {
                toggleFilters.textContent = toggleFilters.dataset.showText;
                filtersContainer.style.display = "none";
                filtersContainer.classList.remove("open");
            } else {
                toggleFilters.textContent = toggleFilters.dataset.hideText;
                filtersContainer.style.display = "block";
                filtersContainer.classList.add("open");
            }
        });
    }

    const perPageSelect = document.getElementById("perPageSelect");
    if (perPageSelect) {
        perPageSelect.addEventListener("change", () => {
            document.getElementById("perPage").value = perPageSelect.value;
            document.getElementById("page").page.value = 1;

            document.querySelector("form.filter-wrap").submit();
        })
    }

    const tooltipElements = document.querySelectorAll("[data-bs-toggle='tooltip']");
    tooltipElements.forEach(element => {
        const tooltip = new bootstrap.Tooltip(element, {
            trigger: "click",
        });
        element.addEventListener("click", () => {
            tooltip.show();
        });
    });
});

function showDialog(title, message, type, callback) {
    const dialog = document.getElementById("dialog");
    if (!dialog) {
        console.error("Dialog not found.");
    }

    const modal = new bootstrap.Modal(dialog);
    dialog.querySelector(".modal-title").innerHTML = title;
    dialog.querySelector(".modal-body").innerHTML = message;

    const modalTypes = dialog.querySelectorAll(".modal-type");
    modalTypes.forEach(element => element.style.display = "none");

    switch (type) {
        case "delete":
            const deleteType = dialog.querySelector(".modal-type-delete");
            if (!deleteType) {
                break;
            }

            deleteType.style.display = "block";
            deleteType.querySelector(".yes-button").addEventListener("click", () => {
                if (typeof (callback) == "function") {
                    callback();
                }
            });
            break;

        default:
            const alertType = dialog.querySelector(".modal-type-alert");
            if (alertType) {
                alertType.style.display = "block";
            }
            break;
    }

    modal.show();
}

// Show confirmation before deletion.
function initConfirmDelete() {
    const forms = document.querySelectorAll("form.confirm-delete");
    forms.forEach(form => {
        form.addEventListener("submit", event => {
            event.preventDefault();

            let message = form.getAttribute("data-message");
            if (!message) {
                if (form.getAttribute("data-delete-multiple") === "true") {
                    message = "Are you sure you want to delete the selected items?"
                } else {
                    message = "Are you sure you want to delete this item?";
                }
            }

            showDialog("Delete Confirmation", message, "delete", () => {
                form.submit();
            });
        });
    });
}

// Show confirmation before action.
function initConfirmAction() {
    const forms = document.querySelectorAll("form.confirm-action");
    forms.forEach(form => {
        form.addEventListener("submit", event => {
            event.preventDefault();

            const title = form.getAttribute("data-title");
            const message = form.getAttribute("data-message");
            showDialog(title, message, "delete", () => {
                form.submit();
            });
        });
    });
}

function initConfirmActionReason() {
    const forms = document.querySelectorAll("form.confirm-action-reason");
    forms.forEach(form => {
        form.addEventListener("submit", event => {
            event.preventDefault();

            const title = form.getAttribute("data-title");

            const messageContent = form.getAttribute("data-message");

            const message = `
                <form id="reason-form">
                    ${escapeHtml(messageContent)}
                    <div class="form-group">
                        <label for="reason-input">Reason</label>
                        <input id="reason-input" class="form-control" type="text" name="reason">
                    </div>
                </form>
            `;

            showDialog(title, message, "delete", () => {
                const value = document.getElementById("reason-input").value;

                const reasonInput = form.querySelector("input[type=hidden][name=reason]");
                if (reasonInput)                {
                    reasonInput.value = value;
                }

                form.submit();
            });
        });
    });
}

function initPopoverReason() {
    const popoverButtons = document.querySelectorAll(".reason-popover-button");
    popoverButtons.forEach(popoverButton => {
        new bootstrap.Popover(popoverButton);

        popoverButton.addEventListener("click", (event) => {
            event.preventDefault();
        });

        popoverButton.addEventListener("show.bs.popover", () => {
            popoverButton.textContent = popoverButton.getAttribute("data-close-text");
        });

        popoverButton.addEventListener("hide.bs.popover", () => {
            popoverButton.textContent = popoverButton.getAttribute("data-show-text");
        });
    });
}

// Disable multiple form submissions
document.body.addEventListener("submit", event => {
    const form = event.target;
    if (form.tagName !== "form") {
        return;
    }

    form.addEventListener("submit", event => {
        console.log("submit");
        event.preventDefault();
    }, {once: true});

    console.log("after submit");
});
